import React, { useEffect, useState } from 'react';
import {
  Grid,
  Row,
  Column,
  Button,
  IconChevronRight,
  Divider,
  BUTTON_VARIANTS,
  CardWrapper,   
  CardBody, 
  Input,
  SimpleTableWrapper,
  SimpleTableBody,   
  SimpleTableData,
  IconAddCircle,
  IconRemove,
  IconCheck,
  ButtonLoader
} from 'cdk-radial';
import useUserInfo from '../../hooks/useUserInfo';
import getEmptyForNull, {
  createAccountObjects,
  validateOrder
} from '../../utils/utils';
import SearchableDropdown from '../../common/SearchableDropdown';
import DatePickerComponent from '../../common/DatePickerComponent';
import { CDK_ORDER_TYPE } from '../../common/staticData';
import moment from 'moment';
import {
  FullWidthTableData,
  StickySimpleTable,
  StickySimpleTableContainer,
  StyledLoader,
  StyledCenterDiv
} from '../../common/StyledComponents';
import GetOrderTableHeaders from './GetOrderTableHeaders';
import fetchOrdersFromDMS from '../../adapters/services/fetchOrdersFromDMS';
import { useOktaAuth } from '@okta/okta-react';
import { v4 } from 'uuid';
import { ZebraSimpleTableRow } from '../../common/styled';
import { useToastProvider } from '../../providers/ToastProvider';
import fetchVinInfo from '../../adapters/services/fetchVinInfo';

export default function GetOrdersWrapper(props: any): JSX.Element {
  const { isFetching, userInfo } = useUserInfo();
  const { authState } = useOktaAuth();

  const addOrderIfNotExists = (existingOrders: any[], newOrder: any) => {
  const alreadyExists = existingOrders.some(
    order => order.orderNumber === newOrder.orderNumber
  );
  return alreadyExists ? existingOrders : [...existingOrders, newOrder];
};

   


  const [getOrderPayload, setGetOrderPayload] = useState({
    orderNumber: '',
    orderDate: '',
    orderType: { label: '', value: '' },
    isExcludePastOrders: true
  });

  const [getOrderData, setGetOrderData] = useState([]);

  const [loader, setLoader] = useState(false);
 const [buttonLoader, setButtonLoader] = useState<{[key:string]:boolean}>({});

  const [defaultLogOnDetails, setDefaultLogOnDetails] = useState([]);

  const [selectedOEM, setSelectedOEM] = useState({
    lable: 'DTNA - Daimler Truck North America',
    value: 'DTNA - Daimler Truck North America'
  });

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!isFetching) {
      const defaultLogOnListTemp: any = createAccountObjects(userInfo);
      setDefaultLogOnDetails(defaultLogOnListTemp);
    }
  }, [isFetching]);

  useEffect(() => {
    const validationMessage: string = validateOrder(
      props.selectedGroup,
      getOrderPayload
    );
    if (validationMessage !== '') {
      setErrorMessage(validationMessage);
    } else {
      setErrorMessage('');
    }
  }, [getOrderPayload, props.selectedGroup]);
  

  const { addErrorToast, addWarningToast } = useToastProvider();

  return (
    <Grid>
      {/* Row for main page */}
      <Row style={{ padding: '0px 0px 8px 0px' }}>
        {/* Column for get order fields */}
        <Column l={9.5} m={12} s={12} xl={9} xs={12} pl={0}>
          {/* Grid for search order */}
          <Grid>
            <Row
              style={{
                backgroundColor: '#F2F2F2',
                borderRadius: '6px',
                overflow: 'hidden',
                padding: '0px',
                borderBottom: '1px solid #C1C8CF'
              }}
            >
              <h3 style={{ paddingLeft: '20px' }}>Search for orders</h3>
            </Row>
            <CardWrapper style={{ padding: '0%', margin: '0px' }}>
              <CardBody>
                <Row>
                  <Column l={6.1} m={12} s={12} xl={6.1} xs={12}>
                    <SearchableDropdown
                      id="input-OEM"
                      label="OEM"
                      defaultOptions={[]}
                      setSelectedOption={() => {}}
                      selectedOption={{}}
                      isRequired={false}
                      isDisabled={true}
                      placeHolder={selectedOEM.value}
                    />
                  </Column>
                  <Column l={4} m={12} s={12} xl={4} xs={12}>
                    <SearchableDropdown
                      id="input-Group"
                      label="Group"
                      defaultOptions={defaultLogOnDetails}
                      setSelectedOption={(option: any) => {
                        props.setSelectedGroup(() => ({
                          groupName: option
                        }));
                      }}
                      selectedOption={props.selectedGroup.groupName}
                      isRequired={true}
                      isDisabled={
                        props.selectedOrders.length === 0 ? false : true
                      }
                      placeHolder={props.selectedGroup.groupName.label}
                      hasClearButton={
                        props.selectedOrders.length > 0 ? false : true
                      }
                    />
                  </Column>
                </Row>
                <Row>
                  <Column l={3} m={12} s={12} xl={3} xs={12}>
                    <div style={{ paddingRight: '6px' }}>
                      <Input
                        dataTestId="test-order-number-input"
                        hideBorder="none"
                        iconPosition="trailing"
                        id="order-number-input"
                        inputDivider="left"
                        label="Order Number"
                        name="order-number"
                        onChange={(event: any) => {
                          setGetOrderPayload(prevState => ({
                            ...prevState,
                            orderNumber: event.target.value
                          }));
                        }}
                        placeholder="Enter Order Number"
                        size="standard"
                        value={getOrderPayload.orderNumber}
                        isRequired={true}
                        isDisabled={
                          getOrderPayload.orderDate !== '' ||
                          getOrderPayload.orderType.value !== ''
                            ? true
                            : false
                        }
                        hasClearButton={true}
                        onInputClear={() => {
                          setGetOrderPayload(prevState => ({
                            ...prevState,
                            orderNumber: ''
                          }));
                        }}
                      />
                    </div>
                  </Column>
                  <Column l={3} m={12} s={12} xl={3} xs={12}>
                    <div style={{ paddingLeft: '8px', paddingRight: '8px' }}>
                      <DatePickerComponent
                        label="Order Date"
                        id="order-date-picker"
                        name="order-date-picker"
                        onDateChange={momentEvent => {                           
                          const tempDate: string | undefined =
                            momentEvent?.format('MM/DD/YYYY');                          
                          setGetOrderPayload(prevState => ({
                            ...prevState,
                            orderDate: tempDate ? tempDate : ''
                          }));
                        }}
                        initialDate={null}
                        isRequired={true}
                        blockedDateRanges={[
                          {
                            endDate: moment('2050-12-08T00:00:00.000Z'),
                            startDate: moment().add(1, 'day')
                          }
                        ]}
                        onDateClear={() => {
                          setGetOrderPayload(prevState => ({
                            ...prevState,
                            orderDate: ''
                          }));
                        }}
                        isDisabled={
                          getOrderPayload.orderNumber != '' ? true : false
                        }
                      />
                    </div>
                  </Column>
                  <Column l={4.14} m={12} s={12} xl={4.14} xs={12}>
                    <div
                      style={{
                        paddingLeft: '8px',
                        paddingRight: '3px'
                      }}
                    >
                      <SearchableDropdown
                        id="input-cdk-order-type"
                        label="CDK Order Type"
                        defaultOptions={CDK_ORDER_TYPE}
                        setSelectedOption={(option: any) => {
                          setGetOrderPayload(prevState => ({
                            ...prevState,
                            orderType: option
                          }));
                        }}
                        selectedOption={getOrderPayload.orderType}
                        isRequired={true}
                        placeHolder={'Select CDK Order Type'}
                        isDisabled={
                          getOrderPayload.orderNumber !== '' ? true : false
                        }
                        hasClearButton={true}
                      />
                    </div>
                  </Column>
                  <Column l={1.6} m={12} s={12} xl={1.6} xs={12}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        marginLeft: '8px',
                        marginTop: '5px'
                      }}
                    >
                      <Button
                        iconColor="primary"
                        text={'Find Orders'}
                        onClick={() => {
                          const validationMessage: string = validateOrder(
                            props.selectedGroup,
                            getOrderPayload
                          );

                          if (validationMessage !== '') {
                            setErrorMessage(validationMessage);
                            return;
                          }
                          // setting loader
                          setLoader(true);

                          
                          const reqPayload: any = {
                            orderNumber: getOrderPayload.orderNumber.trim(),
                            orderDate: getOrderPayload.orderDate,
                            orderType: getOrderPayload.orderType.value,
                            groupName: props.selectedGroup.groupName.value.split("-")[0], // 'BAS'
                            storeId: props.selectedGroup.groupName.storeId, // 'S100092713'
                            isExcludePastOrders: true
                          };
                         
                          fetchOrdersFromDMS(
                            `Bearer ${getEmptyForNull(
                              authState?.accessToken?.accessToken
                            )}`,
                            reqPayload
                          )
                            .then((data: any) => {
                              // adding keys for customerPO, DTNAOrderType, shippingCond & orderRefText
                              data.forEach((order: any) => {
                                order.customerPO = '';
                                order.DTNAOrderType = '';
                                order.shippingCond = {
                                  label: 'F1 - Dlr Assigned Carrier',
                                  value: 'F1'
                                };
                                order.orderRefText = '';
                              });
                              const filteredOrders = data.filter((order: any) => !order.alreadyProcessed);

                              if (filteredOrders.length === 0) {
                                // If all orders are processed, show a proper message
                                addWarningToast("Selected order(s) have already been transmitted.");
                              } else {
                                setGetOrderData(filteredOrders);
                              }                          
                              setLoader(false);
                            })
                            .catch((e: any) => {
                              if(e.message === "404"){
                                addWarningToast("No orders found. " + e.message);
                              }
                              else{
                                addErrorToast("Unable to find orders."+ e.message);
                              }
                              setLoader(false);
                               setGetOrderData([]);
                            });
                        }}
                        size="standard"
                      />
                    </div>
                  </Column>
                  {errorMessage !== '' ? (
                    <p style={{ marginTop: '6px', color: '#E54B61' }}>
                      {errorMessage}
                    </p>
                  ) : (
                    ''
                  )}
                </Row>
                <Row style={{ paddingLeft: '5px' }}>
                  <h4 style={{ margin: '0px' }}>Search results</h4>
                </Row>
                <Row>
                  <SimpleTableWrapper
                    style={{
                      width: '100%'
                    }}
                  >
                    <StickySimpleTableContainer style={{ height: '340px' }}>
                      <StickySimpleTable aria-label="Table">
                        <GetOrderTableHeaders />
                        <SimpleTableBody>
                          {loader ? (
                            <FullWidthTableData colSpan={8}>
                              <StyledLoader label="Loading..." />
                            </FullWidthTableData>
                          ) : getOrderData.length === 0 ? (
                            <FullWidthTableData colSpan={8}>
                              <StyledCenterDiv>
                                No Orders to show.
                              </StyledCenterDiv>
                            </FullWidthTableData>
                          ) : (
                            getOrderData.map((order: any, index: number) => {
                              return (
                                <ZebraSimpleTableRow key={v4()}>
                                  <SimpleTableData colSpan={2}>
                                    {order?.orderNumber}
                                  </SimpleTableData>
                                  <SimpleTableData colSpan={2}>
                                    {order?.orderDate}
                                  </SimpleTableData>
                                  <SimpleTableData colSpan={2}>
                                    {order?.orderType}
                                  </SimpleTableData>
                                  <SimpleTableData colSpan={1}>
                                    <></>
                                  </SimpleTableData>
                                  <SimpleTableData
                                    colSpan={1}
                                    textAlign="center"
                                  >
                                    {props.selectedOrders.some(
                                      (currentOrder: any) =>
                                        currentOrder.orderNumber ===
                                        order.orderNumber
                                    ) ? (
                                      <Button
                                        iconColor="primary"
                                        text={'Added'}
                                        size="standard"
                                        variant={BUTTON_VARIANTS.TEXT}
                                        icon={
                                          <IconCheck
                                            style={{ fill: '#18B210' }}
                                          />
                                        }
                                        style={{ zIndex: '5' }}
                                      />
                                    ) : (
                                      <Button
                                        iconColor="primary"
                                        text={'Add to order'}
                                        onClick={async () => {
                                          try {
                                            setButtonLoader(prev => ({ ...prev, [order.orderNumber]: true }));
                                            const orderNumber = order.orderNumber;
                                            const { groupName } = props.selectedGroup;
                                        
                                            const reqPayload = {
                                              orderNumber,
                                              groupName: groupName.value.split("-")[0],
                                              storeId: groupName.storeId,
                                              isExcludePastOrders: true,
                                              oem: "dtna"
                                            };
                                        
                                            const token = getEmptyForNull(authState?.accessToken?.accessToken);
                                            const orderData :any  = await fetchVinInfo(`Bearer ${token}`, reqPayload);
                                        
                                            if (!orderData) {
                                              addErrorToast("No data returned for the order.");
                                              return;
                                            }
                                        
                                            const enrichedOrder = {
                                              ...orderData,
                                              customerPO: "",
                                              DTNAOrderType: "",
                                              shippingCond: {
                                                label: "F1 - Dlr Assigned Carrier",
                                                value: "F1"
                                              },
                                              orderRefText: ""
                                            }; 

                                            props.setSelectedOrders((prev : any[])=> addOrderIfNotExists(prev, enrichedOrder));                                           
                                             setButtonLoader(prev => ({ ...prev, [order.orderNumber]: false }));
                                          } catch (e) {
                                            console.error(e);
                                            addErrorToast("Error in retrieving order details.");
                                             setButtonLoader(prev => ({ ...prev, [order.orderNumber]: false }));
                                          }
                                        }}
                                        
                                        size="standard"
                                        variant={BUTTON_VARIANTS.TEXT}
                                        icon={buttonLoader[order.orderNumber]  ? (
                                                            <ButtonLoader />
                                                          ) : (
                                                            <IconAddCircle />
                                                             
                                                          )}
                                        style={{ zIndex: '100' }}
                                      />
                                    )}
                                  </SimpleTableData>
                                </ZebraSimpleTableRow>
                              );
                            })
                          )}
                        </SimpleTableBody>
                      </StickySimpleTable>
                    </StickySimpleTableContainer>
                  </SimpleTableWrapper>
                </Row>
              </CardBody>
            </CardWrapper>
          </Grid>
        </Column>
        {/* Column for selected orders */}
        <Column l={2.5} m={12} s={12} xl={3} xs={12}>
          <Grid>
            <Row
              style={{
                backgroundColor: '#E7F3FF',
                overflow: 'hidden',
                padding: '0px',
                marginLeft: '6px',
                borderRadius: '6px',
                borderBottom: '1px solid #C1C8CF'
              }}
            >
              <h3 style={{ paddingLeft: '20px' }}>Selected orders</h3>
            </Row>

            <CardWrapper
              style={{
                padding: '0%',
                marginLeft: '6px',
                height: errorMessage !== '' ? '595px' : '553px'
              }}
            >
              <CardBody style={{ overflowY: 'auto', maxHeight: '100%' }}>
                {props.selectedOrders.map((order: any) => (
                  <div>
                    <Row>
                      <Column l={8} m={12} s={12} xl={8} xs={12}>
                        <Row style={{ padding: '0px' }}>
                          <div style={{ display: 'flex' }}>
                            <p style={{ margin: '0px', fontWeight: 500, fontSize: "14px" }}>PO</p>
                            <p
                              style={{
                                margin: '0px',
                                marginLeft: '22px',
                                fontWeight: 500,
                                fontSize: "14px"
                              }}
                            >
                              {order.orderNumber}
                            </p>
                          </div>
                        </Row>
                        <Row style={{ padding: '0px' }}>
                          <div style={{ display: 'flex' }}>
                            <p style={{ margin: '0px', color: '#4D4D4D', fontSize: "14px" }}>
                              Date
                            </p>
                            <p
                              style={{
                                margin: '0px',
                                marginLeft: '12px',
                                color: '#4D4D4D', fontSize: "14px"  
                              }}
                            >
                              {order.orderDate}
                            </p>
                          </div>
                        </Row>
                      </Column>
                      <Column l={4} m={12} s={12} xl={4} xs={12}>
                        <Button
                          iconColor="primary"
                          text={'Remove'}
                          onClick={() => {
                            // filtering current data
                            const tempFilteredValue: any =
                              props.selectedOrders.filter((item: any) => {
                                if (item.orderNumber !== order?.orderNumber) {
                                  return true;
                                } else {
                                  return false;
                                }
                              });
                            props.setSelectedOrders(tempFilteredValue);
                          }}
                          size="small"
                          variant={BUTTON_VARIANTS.TEXT}
                          icon={<IconRemove style={{ fill: 'red' }} />}
                          style={{
                            zIndex: '5',
                            marginTop: '3%',
                            marginLeft: '10%',
                            marginBottom: '2%'
                          }}
                        />
                      </Column>
                    </Row>
                    <Divider />
                  </div>
                ))}
              </CardBody>
            </CardWrapper>
          </Grid>
        </Column>
      </Row>
      <Divider style={{opacity:"70%"}}></Divider>
      {/*footer navigation*/}
      <Grid>
        <Row>
          {/* <Column l={8} m={12} s={12} xl={8} xs={12}></Column> */}
          <Column l={12} m={12} s={12} xl={12} xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                iconColor="primary"
                icon={<IconChevronRight />}
                data-testid="stepper-next-button"
                text={'Next'}
                onClick={() => props.setActiveState(props.activeState + 1)}
                variant={BUTTON_VARIANTS.TEXT}
                isIconTrailing
                style={{ backgroundColor: '#E8F1FC' }}
                isDisabled={props.selectedOrders.length === 0 ? true : false}
              />
            </div>
          </Column>
        </Row>
      </Grid>
    </Grid>
  );
}
